// extracted by mini-css-extract-plugin
export var overlay = "styles-module--overlay--HZFdC";
export var w100 = "styles-module--w-100--2qcx_";
export var h100 = "styles-module--h-100--2YdCI";
export var positionAbsolute = "styles-module--position-absolute--J4k5R";
export var positionRelative = "styles-module--position-relative--3yXmu";
export var margin1 = "styles-module--margin-1--17KuZ";
export var marginTop1 = "styles-module--margin-top-1--3A8eI";
export var marginTop2 = "styles-module--margin-top-2--d27nk";
export var padding1 = "styles-module--padding-1--g0Npm";
export var paddingTop1 = "styles-module--padding-top-1--3osCH";
export var container = "styles-module--container--J4y9k";
export var flex = "styles-module--flex--2tA3M";
export var flexColumn = "styles-module--flex-column--1Zghe";
export var justifyStart = "styles-module--justify-start--1wtY4";
export var justifyCenter = "styles-module--justify-center--UW62R";
export var justifyEnd = "styles-module--justify-end--3insP";
export var justifyBetween = "styles-module--justify-between--XxmHT";
export var justifyAround = "styles-module--justify-around--1QGS-";
export var alignStart = "styles-module--align-start--T9f6e";
export var alignCenter = "styles-module--align-center--i75ln";
export var alignEnd = "styles-module--align-end--3Ob5x";
export var textCenter = "styles-module--text-center--uxtV9";
export var textJustify = "styles-module--text-justify--1BZS0";
export var formControl = "styles-module--form-control--E3R91";
export var rounded10 = "styles-module--rounded-10--39b6J";
export var btn = "styles-module--btn--2RYMR";
export var btnPrimary = "styles-module--btn-primary--ln9lG";
export var btnDark = "styles-module--btn-dark--3KUBX";
export var btnLg = "styles-module--btn-lg--3SOd3";